module.exports = __webpack_public_path__ + "assets/2c330d23f75c992cabaf48bba01c4d9d.mp3";